module.exports = __webpack_public_path__ + "static/media/Mali.27e741b8.png";